import { render } from "./BudgetItemTable.vue?vue&type=template&id=97463d08&scoped=true"
import script from "./BudgetItemTable.vue?vue&type=script&lang=js"
export * from "./BudgetItemTable.vue?vue&type=script&lang=js"

import "./BudgetItemTable.vue?vue&type=style&index=0&id=97463d08&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97463d08"]])

export default __exports__